module.exports = __webpack_public_path__ + "img/developer.4455cf10.svg";